import {
  INTAKE_SUMMARY_SOURCE,
  PreVisitSummaryCardConnected,
  ProviderEventType,
  toIntakeFormReviewSource,
  useSetCoachConversation,
} from '@grow-therapy-team/seedling-components';

import { AppointmentType } from '../../schedule-preview/types';
import { useProviderUtilizationExperiment } from '../../useProviderUtilizationExperiment';
import { IntakeSummaryConnectedWithFormsPrefetch } from '../IntakeSummaryConnectedWithFormsPrefetch';
import { useOpenIntakeFormResponseCallback } from '../useOpenIntakeFormResponseCallback';
import { usePreVisitSummaryCardWrapper } from './usePreVisitSummaryCardWrapper';

export function PreVisitSummaryCardWrapper() {
  const {
    appointmentShortId,
    patientShortId,
    appointmentType,
    nudgeContext,
    preVisitSummaryCardComponent,
    resourceButtonOnClickHandlers,
  } = usePreVisitSummaryCardWrapper();

  const { setCoachConversation } = useSetCoachConversation();
  const openIntakeFormResponse = useOpenIntakeFormResponseCallback();
  const {
    includeLiveMeasures,
    exposureRef,
    isLoading: isProviderUtilizationExperimentLoading,
  } = useProviderUtilizationExperiment();

  if (!appointmentShortId || !patientShortId || isProviderUtilizationExperimentLoading) {
    return null;
  }

  const isIntakeAppointment = appointmentType === AppointmentType.Intake;

  return (
    <div ref={exposureRef}>
      <PreVisitSummaryCardConnected
        appointmentShortId={appointmentShortId}
        patientShortId={patientShortId}
        providerViewEventType={ProviderEventType.VIEWED_PRE_VISIT_SUMMARY_NO_MEDICAL_RECORD_TELEHEALTH}
        includeTitle
        includeLiveMeasures={includeLiveMeasures}
        clinicalRiskNudgeEnhancementsContext={nudgeContext}
        nudgeContext={nudgeContext}
        preVisitSummaryCardComponent={preVisitSummaryCardComponent}
        onClickUnreadCoachConversation={setCoachConversation}
        resourceButtonOnClickHandlers={resourceButtonOnClickHandlers}
        betweenNudgesAndContent={
          isIntakeAppointment ? (
            <IntakeSummaryConnectedWithFormsPrefetch
              patientShortId={patientShortId}
              appointmentShortId={appointmentShortId}
              showViewFullIntakeButton
              source={INTAKE_SUMMARY_SOURCE.TELEHEALTH_CLIENT_INFO_DRAWER}
              isInverse
              onViewFullIntake={() => {
                void openIntakeFormResponse({
                  patientShortId,
                  source: toIntakeFormReviewSource(INTAKE_SUMMARY_SOURCE.TELEHEALTH_CLIENT_INFO_DRAWER),
                });
              }}
            />
          ) : undefined
        }
        isInverse
      />
    </div>
  );
}
